module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"新闻1":"[朝 闻 天下] Hubei Xiantao is full of horsepower to produce medical protective materials","新闻2":"CCTV \\"Newscast\\" focuses on Xiantao! This time because ...","新闻3":"Hubei Daily Concerned about Xiantao: \\"No Stop\\" Enterprises Are \\"Arsenals\\""},"zh":{"新闻1":"[朝闻天下]湖北仙桃开足马力 生产医用防护物资","新闻2":"央视《新闻联播》聚焦仙桃！这次是因为……","新闻3":"湖北日报关注仙桃：“停不得”企业就是“兵工厂”"}}')
  delete Component.options._Ctor
}
